module.exports = __webpack_public_path__ + "img/EE12938421.a275fc95.png";